// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__vzmN8","spinner":"Spinner_spinner__Z6H3Z","darkSpinner":"Spinner_darkSpinner__kivU8"};